module.exports = __webpack_public_path__ + "img/contact.9d14804.jpg";